export const CREATE_BOOKMARK = 'dt/bookmarks/CREATE_BOOKMARK';
export const UPDATE_BOOKMARK = 'dt/bookmarks/UPDATE_BOOKMARK';
export const DELETE_BOOKMARK_SUCCESS = 'dt/bookmarks/DELETE_BOOKMARK_SUCCESS';
export const DELETE_BOOKMARK = 'dt/bookmarks/DELETE_BOOKMARK';
export const SET_CREATING_BOOKMARK = 'dt/bookmarks/SET_CREATING_BOOKMARK';

export const deleteBookmark = (fileId, id) => ({
  type: DELETE_BOOKMARK,
  fileId,
  id,
});

export const createBookmark = (fileId, bookmark) => ({
  type: CREATE_BOOKMARK,
  fileId,
  bookmark,
});

export const updateBookmark = (fileId, bookmarkId, bookmark) => ({
  type: UPDATE_BOOKMARK,
  fileId,
  bookmarkId,
  bookmark,
});

export const creatingBookMark = (isCreating) => ({
  type: SET_CREATING_BOOKMARK,
  isCreating,
});
